module.exports = __webpack_public_path__ + "img/ics_o_active_client.97d957a9.svg";